// src/hooks/programs/useRestoreProgram.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { restoreProgram } from "../../api/apiPrograms";
import parseError from "../../utils/parseError";

const useRestoreProgram = () => {
    const queryClient = useQueryClient();

    const {
        mutate: restoreProgramMutate,
        isPending,
        isLoading,
    } = useMutation({
        mutationFn: restoreProgram,
        onSuccess: (response) => {
            toast.success(response.message);
            queryClient.invalidateQueries({ queryKey: ["programs"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to restore program");
        },
    });

    return {
        restoreProgramMutate,
        isPending: isPending || isLoading,
    };
};

export default useRestoreProgram;
